//
// Module for the login MFA page
//
rs.module("user/account/mfa",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, cssClasses) {

            var form = $.js(jsSelectors.mfaForm);

            form.js(jsSelectors.trustDeviceCheckbox).change(function () {
                form.js(jsSelectors.trustedBrowserName).toggleClass(cssClasses.visible, $(this).is(":checked"));
            });
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);
